export default __webpack_public_path__ + "static/4-454b98d0fd06332570d4f5582b1e42a6.png";